export default __webpack_public_path__ + "d71bdb4e498cce7ab31fed78287a1e8f.svg";